<template>
    <ContentQuery path="/meta/trading-hours" v-slot="{ data }" find="one">
        <div class="trading-hours">
            <p>{{ data.days }}</p>
            <p>{{ data.hours }}</p>
        </div>
    </ContentQuery>
</template>